export default __webpack_public_path__ + "static/media/md_bauernhof_logo_2021.d265bcea.svg";